{
    "attendanceConfiguration": "Global Attendance Configuration:",
    "day": "Day",
    "period": "Period",
    "timetableNotConfigured": "Timetable not configured-Can’t switch to period",
    "attendance": "Attendance",
    "timeTable": "Time Table",
    "subjects": "Subjects",
    "classStandards": "Class Standards",
    "categories": "Categories",
    "NA": "NA",
    "PERIOD": "PERIOD",
    "DAY": "DAY",
    "classNotAvailableMessage": "Class not available. Please add at least one class to configure",
    "timetableIsNotConfiguredMessage": "Timetable is not configured for this class can't switch to period",
    "mixedAttendanceConfigurationMessage": "Some classes have individual configurations. Changing this toggle will apply to all classes.",
    "globalAttendanceSwitchMessage": "Are you sure you want to switch?",
    "cancel": "Cancel",
    "switch": "Switch",
    "classNotExist": "No details are available for the searched class."
}